import { AlertCard, Link } from "@caprikorn/dynamo-ui";
import type { FC } from "react";

import {
  CLOSING_TARIFF_SHIELD_FORM_DATE,
  IS_TARIFF_FORM_COMPLETION_DISABLED,
} from "@core/core.constants";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import type { ShieldStatusSwitcherProps } from "./ShieldStatusSwitcher.types";
import { computeNoCertificateCases } from "../shield.utils";
import classes from "./ShieldStatusSwitcher.module.css";
import { ShieldCertificateDisplay } from "../ShieldCertificateDisplay/ShieldCertificateDisplay";

const ASSISTANCE_FOR_SME_WITH_RISING_ENERGY_PRICES_LINK =
  "https://www.economie.gouv.fr/entreprises/tpe-pme-aides-hausse-prix-energie";

export const ShieldStatusSwitcher: FC<ShieldStatusSwitcherProps> = ({
  data,
}) => {
  const { t } = useCustomTranslation("main");

  const noCertificateCases = computeNoCertificateCases({
    isShieldRejected: data.isShieldRejected,
    isTariffShieldFormClose: IS_TARIFF_FORM_COMPLETION_DISABLED,
  });

  const isCertificateAvailable = data.certificate && !data.isShieldRejected;

  return (
    <div className={classes.container}>
      {isCertificateAvailable && data.certificate ? (
        <ShieldCertificateDisplay certificate={data.certificate} />
      ) : (
        <AlertCard variant={noCertificateCases.status}>
          <AlertCard.Title>
            {t(`shield.noStatement.${noCertificateCases.reason}`, {
              date: new Date(CLOSING_TARIFF_SHIELD_FORM_DATE),
            })}
          </AlertCard.Title>
          {noCertificateCases.reason === "possible" && (
            <AlertCard.Description className={classes.description}>
              <Link
                className="font-body-highlight"
                href={ASSISTANCE_FOR_SME_WITH_RISING_ENERGY_PRICES_LINK}
                rel="noreferrer"
                target="_blank"
                type="paragraph-lg"
              >
                {t("shield.governmentWebsite")}
              </Link>
              <p className="font-body-highlight">
                {t("shield.declareElegibility")}
              </p>
              <ul className={classes.list}>
                <li className="font-body-highlight">
                  {t("shield.conditions.multiSite")}
                </li>
                <li className="font-body-highlight">
                  {t("shield.conditions.warning")}
                </li>
                <li className="font-body-highlight">
                  {t("shield.conditions.deadline", {
                    date: new Date(CLOSING_TARIFF_SHIELD_FORM_DATE),
                  })}
                </li>
                <li className="font-body-highlight">
                  {t("shield.conditions.retroactive")}
                </li>
              </ul>
            </AlertCard.Description>
          )}
        </AlertCard>
      )}
    </div>
  );
};
